<template>
  <v-dialog scrollable persistent v-model="dialogShow" max-width="1000px">
    <template v-slot:activator="{ on }">
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            v-show="addButton"
            class="mt-5 mr-2"
            v-on="on"
            absolute
            dark
            fab
            top
            right
            color="primary"
            @click="openForm()"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </template>
        <span>Adicionar usuário</span>
      </v-tooltip>
      <!-- <v-btn color="primary" dark class="mb-2" @click="openForm()">Novo Cliente</v-btn> -->
    </template>
    <v-card>
      <v-system-bar color="primary" dark>
        <v-spacer></v-spacer>
        <v-icon color="#fff" @click="resetDialog">close</v-icon>
      </v-system-bar>
      <v-card-title class="mb-0 pb-0">
        <span class="title grey--text text--darken-2">{{
          formData.id ? "Editar cliente" : "Novo cliente"
        }}</span>
      </v-card-title>
      <v-card-text class="mt-0 pt-0">
        <v-form
          ref="clientUserForm"
          v-model="validForm"
          lazy-validation
          class="mt-0 pt-0"
        >
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex sm12 md6>
                <v-layout row wrap pa-2>
                  <v-flex sm12>
                    <v-text-field
                      v-model="formData.name"
                      label="Nome completo"
                      :rules="$store.state.formRules.required"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm12>
                    <v-text-field
                      v-model="formData.document"
                      label="CPF/CNPJ"
                      :mask="
                        formData.document.length <= 11
                          ? '###.###.###-########'
                          : '##.###.###/####-##'
                      "
                      :rules="$store.state.formRules.cpfCnpjRules"
                    ></v-text-field>
                  </v-flex>

                  <v-flex sm12>
                    <v-text-field
                      v-model="formData.email"
                      label="E-mail"
                      :rules="$store.state.formRules.emailRules"
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm12 md6>
                <v-layout row wrap pa-2>
                  <v-flex xs12>
                    <v-select
                      class="pt-2"
                      v-model="formData.profile_id"
                      :items="profiles"
                      item-text="name"
                      item-value="id"
                      :rules="$store.state.formRules.required"
                      label="Selecione o perfil do usuário"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 v-if="allCondsSel">
                    <v-checkbox
                      v-model="allCondsSel"
                      :label="`Todos os condominios selecionados`"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs12 v-if="!allCondsSel">
                    <v-select
                      id="condUsers"
                      class="condUsersMiniChips"
                      small-chips
                      v-model="formData.condominium_id"
                      :items="condominiums"
                      item-text="name_fantasy"
                      item-value="id"
                      @change="selectAll"
                      label="Selecione os condomínios"
                      multiple
                    ></v-select>

                    <!-- <v-autocomplete
                      :height="`${formData.condominium_id.length ? 'auto' : '55px'}`"
                      v-model="formData.condominium_id"
                      :disabled="isUpdating"
                      :items="condominiums"
                      hide-selected
                      :menu-props="{closeOnContentClick:true}"
                      :rules="$store.state.formRules.requiredAutoComplete"
                      box
                      chips
                      color="blue-grey lighten-2"
                      hint="Adicione os condomínios que o usuário terá acesso."
                      persistent-hint
                      label="Condomínios"
                      item-text="name_fantasy"
                      item-value="id"
                      multiple
                    >
                      <template v-slot:selection="data">
                        <v-chip
                          :selected="data.selected"
                          close
                          class="chip--select-multi"
                          @input="removeCond(data.item)"
                        >
                          <v-avatar>
                            <img :src="data.item.avatar" />
                          </v-avatar>
                          {{ data.item.name_fantasy }}
                        </v-chip>
                      </template>
                      <template v-slot:item="data">
                        <template v-if="typeof data.item !== 'object'">
                          <v-list-tile-content v-text="data.item"></v-list-tile-content>
                        </template>
                        <template v-else>
                          <v-list-tile-avatar>
                            <img :src="data.item.avatar" />
                          </v-list-tile-avatar>
                          <v-list-tile-content>
                            <v-list-tile-title v-html="data.item.name_fantasy"></v-list-tile-title>
                            <v-list-tile-sub-title v-html="data.item.name_company"></v-list-tile-sub-title>
                          </v-list-tile-content>
                        </template>
                      </template>
                    </v-autocomplete>-->
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blueGrey darken-1" flat @click="resetDialog"
          >Cancelar</v-btn
        >
        <v-btn v-if="!viewForm" color="primary" flat @click="doSave"
          >Salvar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const defaultForm = {
  name: '',
  condominium_id: [],
  document: '',
  email: '',
  profile_id: ''
}
export default {
  name: 'UsersForm',

  props: {
    addButton: Boolean,
    openForm: Function,
    closeForm: Function,
    saveUser: Function,
    dialog: Boolean,
    editFormData: Object
  },

  data () {
    return {
      allCondsSel: false,
      viewForm: false,
      isUpdating: false,
      condominiums: [],
      profiles: [],
      formData: { ...defaultForm },
      validForm: true
    }
  },

  computed: {
    dialogShow () {
      return this.dialog
    }
  },

  mounted () {
    this.getComdominiums()
    this.getProfiles()
  },

  watch: {
    allCondsSel (v) {
      if (!v) {
        this.formData.condominium_id = []
      }
    },

    formData: {
      handler (val) {
        this.chipSize(val.condominium_id.length)
      },
      deep: true
    },

    dialogShow (val) {
      if (val) {
        if (this.$props.editFormData) {
          if (this.$props.editFormData.view) {
            this.viewForm = true
          } else {
            this.viewForm = false
          }

          if (
            this.condominiums.length - 1 ===
            this.editFormData.condominium_id.length
          ) {
            this.allCondsSel = true
          }
          this.formData = { ...this.editFormData }
        }
      } else {
        this.allCondsSel = false
        this.$refs.clientUserForm.resetValidation()
        this.formData = { ...defaultForm }
      }
    }
  },

  methods: {
    selectAll (e) {
      if (e.indexOf('all') > -1) {
        this.allCondsSel = true
        this.formData.condominium_id = this.condominiums.map((cond) => cond.id)
      }
      // document.querySelector('.v-menu__content').style.display = "none";
      console.log('---', e)
    },

    chipSize (size) {
      let chips = document.querySelector(
        '.condUsersMiniChips div.v-input__control'
      )
      if (!chips) {
        return
      }
      chips.classList.remove('size_50')
      chips.classList.remove('size_33')
      chips.classList.remove('size_25')
      chips.classList.remove('size_20')
      if (size >= 5) {
        chips.classList.add('size_20')
      }
      switch (size) {
        case 2:
          chips.classList.add('size_50')
          break
        case 3:
          chips.classList.add('size_33')
          break
        case 4:
          chips.classList.add('size_25')
          break
        default:
      }
    },

    getComdominiums () {
      let obj = {
        url: '/api/condominium',
        query: '',
        method: 'get',
        noLoader: true
      }
      this.$store.dispatch('request/doRequest', obj).then((response) => {
        this.condominiums = response.data
        this.condominiums.unshift({
          name_fantasy: 'Selecionar todos',
          id: 'all'
        })
      })
    },

    getProfiles () {
      let obj = {
        url: '/api/profile',
        query: '',
        method: 'get',
        noLoader: true
      }
      this.$store.dispatch('request/doRequest', obj).then((response) => {
        this.profiles = response.data
      })
    },

    removeCond (item) {
      const index = this.formData.condominium_id.indexOf(item.id)
      if (index >= 0) this.formData.condominium_id.splice(index, 1)
    },

    resetDialog () {
      this.$props.closeForm()
    },

    doSave () {
      // console.log(this.formData);
      // return;
      if (!this.$refs.clientUserForm.validate()) {
        return
      }

      let index = this.formData.condominium_id.indexOf('all')

      if (index >= 0) this.formData.condominium_id.splice(index, 1)
      const callback = function () {
        this.$props.closeForm()
      }

      this.$props.saveUser(this.formData, callback)
    }
  }
}
</script>

<style>
.condUsersMiniChips div.v-input__control .v-chip {
  max-width: 95% !important;
  overflow: hidden;
}
.condUsersMiniChips div.v-input__control.size_50 .v-chip {
  max-width: 49% !important;
}
.condUsersMiniChips div.v-input__control.size_33 .v-chip {
  max-width: 32% !important;
}
.condUsersMiniChips div.v-input__control.size_25 .v-chip {
  max-width: 24% !important;
}
.condUsersMiniChips div.v-input__control.size_20 .v-chip {
  max-width: 19% !important;
}
</style>
